import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexKnowledgebase',
  setup(__props) {

const knowledgebaseSearch = defineAsyncComponent(() => import("@/components/theme/knowledgebase/knowledgebaseSearch.vue"))
const faqWidgets = defineAsyncComponent(() => import("@/components/theme/knowledgebase/faqWidgets.vue"))
const browseArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/browseArticles.vue"))
const featuresFaq = defineAsyncComponent(() => import("@/components/theme/knowledgebase/featuresFaq.vue"))
const latestArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/latestArticles.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Knowledgebase",
      title: "Knowledgebase"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(knowledgebaseSearch)),
        _createVNode(_unref(faqWidgets)),
        _createVNode(_unref(browseArticles)),
        _createVNode(_unref(featuresFaq)),
        _createVNode(_unref(latestArticles))
      ])
    ])
  ], 64))
}
}

})